import { Component, inject } from '@angular/core';

import { ENABLE_STANDALONE_NAVIGATION } from '../../../shell/navigation/standalone-navigation';
import { TranslationService } from '../../../shell/translation-service';

// The Shell owns federated diagnostics; loader errors are also logged by the service.
@Component({
  selector: 'ima-translation-status-banner',
  templateUrl: './translation-status-banner.html',
  styleUrl: './translation-status-banner.scss',
})
export class TranslationStatusBanner {
  protected readonly isStandalone =
    inject(ENABLE_STANDALONE_NAVIGATION, { optional: true }) ?? false;

  protected readonly translationService = inject(TranslationService);
}
